export const InformacoesComplementaresDTO = {
  modalidadePesca: null,
  localizacaoPreferencialPesca: null,
  rendaMensal: null,
  diasPescaPorAno: 1,
  gastoMedioPesca: 0,
  localPesca: null,
  materialPesca: null,
  tipoIsca: 1,
  agenciaTurismo: null,
  peixeMaisPescado: null
};

export const ModalidadeResource = {
  PESCA_ESPORTIVA: 0,
  PESCA_RECREATIVA: 1
};
